import { useCallback } from 'react';
import { keycloakLogout } from 'store/components/auth/authActions';

export function useLogoutAction() {
    return useCallback(() => {
        return keycloakLogout(true);
    }, []);
}
